// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kpDX","footer":"styles_footer__3Hzsj"};